export const LocalStorageKey = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
};

export const popupType = {
  success: "success",
  warning: "warning",
  failed: "failed",
};
export const projectDetails = {
  STANDARD: {
    projectName: "STANDARD",
    project: 5,
    siteAudit: 15000,
    blogGeneration: 15,
    price: 5999,
    keywordResearch: 15,
    keywordRanking: 15,
    totalSiteAudit: 15000,
  },
  PREMIUM: {
    projectName: "PREMIUM",
    project: 10,
    siteAudit: 25000,
    blogGeneration: 20,
    price: 7999,
    keywordResearch: 20,
    keywordRanking: 20,
    totalSiteAudit: 25000,
  },
  ENTERPRISES: {
    projectName: "ENTERPRISES",
    project: 15,
    siteAudit: 40000,
    blogGeneration: 100,
    price: 21999,
    keywordResearch: 150,
    keywordRanking: 150,
    totalSiteAudit: 40000,
  },
  FREEMIUM: {
    projectName: "FREEMIUM",
    project: 5,
    siteAudit: 5000,
    blogGeneration: 0,
    price: 0,
    keywordResearch: 0,
    keywordRanking: 0,
    totalSiteAudit: 5000,
  },
};

export const usersCreditsYearly = {
  STANDARD: {
    siteAudit: 1800000,
    project: 50,
    blogGeneration: 150,
    keywordResearch: 150,
    keywordRanking: 150,
    aiBlogGenerate: 1000000,
    totalSiteAudit: 1800000,
    price: 64000,
  },
  PREMIUM: {
    siteAudit: 2500000,
    project: 100,
    blogGeneration: 200,
    keywordResearch: 200,
    keywordRanking: 200,
    aiBlogGenerate: 1500000,
    totalSiteAudit: 2500000,
    price: 85000,
  },
  ENTERPRISES: {
    siteAudit: 4000000,
    project: 500,
    blogGeneration: 1500,
    keywordResearch: 1500,
    keywordRanking: 1500,
    aiBlogGenerate: 2500000,
    totalSiteAudit: 4000000,
    price: 233000,
  },
  FREEMIUM: {
    projectName: "FREEMIUM",
    project: 5,
    siteAudit: 5000,
    blogGeneration: 0,
    price: 0,
    keywordResearch: 0,
    keywordRanking: 0,
    totalSiteAudit: 5000,
  },
};

export const timeList = [
  {
    value: "m1",
    label: "Select Time Period",
  },
  {
    value: "d1",
    label: "Past 1 day",
  },
  {
    value: "d2",
    label: "Past 2 day",
  },
  {
    value: "d3",
    label: "Past 3 day",
  },
  {
    value: "d4",
    label: "Past 4 day",
  },
  {
    value: "d5",
    label: "Past 5 day",
  },
  {
    value: "d6",
    label: "Past 6 day",
  },
  {
    value: "w1",
    label: "Past 1 week",
  },
  {
    value: "w2",
    label: "Past 2 week",
  },
  {
    value: "w3",
    label: "Past 3 week",
  },
  {
    value: "w4",
    label: "Past 4 week",
  },
  {
    value: "m2",
    label: "Past 2 month",
  },
  {
    value: "m3",
    label: "Past 3 month",
  },
  {
    value: "m4",
    label: "Past 4 month",
  },
  {
    value: "m5",
    label: "Past 5 month",
  },
  {
    value: "m6",
    label: "Past 6 month",
  },
  {
    value: "m7",
    label: "Past 7 month",
  },
  {
    value: "m8",
    label: "Past 8 month",
  },
  {
    value: "m9",
    label: "Past 9 month",
  },
  {
    value: "m10",
    label: "Past 10 month",
  },
  {
    value: "m11",
    label: "Past 11 month",
  },
  {
    value: "y1",
    label: "Past 1 year",
  },
  {
    value: "y2",
    label: "Past 2 year",
  },
  {
    value: "y3",
    label: "Past 3 year",
  },
  {
    value: "y4",
    label: "Past 4 year",
  },
  {
    value: "y5",
    label: "Past 5 year",
  },
  {
    value: "y6",
    label: "Past 6 year",
  },
  {
    value: "y7",
    label: "Past 7 year",
  },
  {
    value: "y8",
    label: "Past 8 year",
  },
  {
    value: "y9",
    label: "Past 9 year",
  },
  {
    value: "y10",
    label: "Past 10 year",
  },
];
export const defultSubscriptionType = "FREEMIUM";
